/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const channelDeliveryOutcomeDataOutcomeSchema = z.enum(['sent', 'skipped', 'failed'])

export type ChannelDeliveryOutcomeDataOutcomeSchema = z.infer<typeof channelDeliveryOutcomeDataOutcomeSchema>
